import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  isLoggedIn =  JSON.parse(localStorage.getItem('isLoggedIn') || "false");

}
